var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "DeviceAppBarPage",
    { attrs: { title: _vm.pageTitle } },
    [
      _c("KPageContainer", { staticClass: "device-container" }, [
        _c(
          "div",
          [
            _c("HeaderWithOptions", {
              attrs: { headerText: _vm.coreString("channelsLabel") },
              scopedSlots: _vm._u([
                {
                  key: "options",
                  fn: function () {
                    return [
                      _c(
                        "KButtonGroup",
                        [
                          _vm.channelsAreInstalled
                            ? _c("KButton", {
                                style: { margin: "16px 8px -16px 0" },
                                attrs: {
                                  hasDropdown: "",
                                  appearance: "raised-button",
                                  text: _vm.coreString("optionsLabel"),
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "menu",
                                      fn: function () {
                                        return [
                                          _c("KDropdownMenu", {
                                            attrs: {
                                              position: "bottom left",
                                              options: _vm.dropdownOptions,
                                            },
                                            on: { select: _vm.handleSelect },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  3972369525
                                ),
                              })
                            : _vm._e(),
                          _c("KButton", {
                            staticStyle: {
                              "margin-top": "16px",
                              "margin-bottom": "-16px",
                            },
                            attrs: { text: _vm.$tr("import"), primary: true },
                            on: {
                              click: function ($event) {
                                return _vm.startImportWorkflow()
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _vm.managedTasks.length > 0
              ? _c("TasksBar", {
                  attrs: {
                    tasks: _vm.managedTasks,
                    taskManagerLink: { name: "MANAGE_TASKS" },
                  },
                  on: { clearall: _vm.handleClickClearAll },
                })
              : _vm._e(),
            !_vm.channelsAreInstalled && !_vm.channelListLoading
              ? _c("p", [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$tr("emptyChannelListMessage")) +
                      "\n      "
                  ),
                ])
              : _vm._e(),
            _c(
              "div",
              { staticClass: "channels-list" },
              [
                _vm.channelListLoading
                  ? _c("KCircularLoader")
                  : _c(
                      "div",
                      _vm._l(_vm.sortedChannels, function (channel) {
                        return _c("ChannelPanel", {
                          key: channel.id,
                          attrs: {
                            channel: channel,
                            disabled: _vm.channelIsBeingDeleted(channel.id),
                            showNewLabel: _vm.showNewLabel(channel.id),
                          },
                          on: {
                            select_delete: function ($event) {
                              _vm.deleteChannelId = channel.id
                            },
                            select_manage: function ($event) {
                              return _vm.handleSelectManage(channel.id)
                            },
                          },
                        })
                      }),
                      1
                    ),
              ],
              1
            ),
            _c("SelectTransferSourceModal", {
              attrs: { pageName: _vm.pageName },
            }),
            _vm.deleteChannelId
              ? _c("DeleteChannelModal", {
                  attrs: { channelTitle: _vm.selectedChannelTitle },
                  on: {
                    submit: _vm.handleDeleteChannel,
                    cancel: function ($event) {
                      _vm.deleteChannelId = null
                    },
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }